module.exports = __webpack_public_path__ + "img/chanceofathunderstorm.e8580b40.png";